import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './Navbar.css';

export default function Navbar() {
  const { user, logout, fetchMe } = useAuthStore();
  const navigate = useNavigate();
  const [time, setTime] = useState(new Date());

  useEffect(() => { fetchMe(); const t = setInterval(() => setTime(new Date()), 1000); return () => clearInterval(t); }, [fetchMe]);

  return (
    <nav className="navbar">
      <div className="nb-logo">
        <div className="nb-icon"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg></div>
        <span>KAMERA</span>
      </div>
      <div className="nb-links">
        {[['/', 'CANLI'], ['/archive', 'ARXİV'], ['/system', 'SİSTEM'], ['/analytics', 'ANALİTİKA'], ['/modem', 'MODEM'], ['/settings', 'AYARLAR']].map(([to, label]) => (
          <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `nb-link${isActive ? ' active' : ''}`}>{label}</NavLink>
        ))}
      </div>
      <div className="nb-right">
        <span className="nb-clock">{time.toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span>
        <span className={`nb-role ${user?.role}`}>{user?.role?.toUpperCase()}</span>
        <span className="nb-user">{user?.username}</span>
        <button className="nb-logout" onClick={async () => { await logout(); navigate('/login'); }}>⏻</button>
      </div>
    </nav>
  );
}
